/*document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "aria-hidden") {
                const element = mutation.target;
                const isHidden = element.getAttribute("aria-hidden") === "true";
                const anchor = element.querySelector(".announcement-bar a");

                if (anchor) {
                    if (isHidden) {
                        anchor.setAttribute("tabindex", "-1");
                    } else {
                        anchor.removeAttribute("tabindex");
                    }
                }
            }
        });
    });

    // Select all announcement bars
    document.querySelectorAll(".announcement-bar").forEach((bar) => {
        observer.observe(bar, { attributes: true, attributeFilter: ["aria-hidden"] });
    });
});*/

document.addEventListener('DOMContentLoaded', () => {
  // Function to handle accessibility for a gallery
  function setupGalleryAccessibility(gallery) {
    function updateCellsTabindex() {
      const selectedCell = gallery.querySelector('.gallery-cell.is-selected');
      const allCells = gallery.querySelectorAll('.gallery-cell');
      
      // initially Set tabindex=-1 for all cells
      allCells.forEach(cell => {
        const focusableElements = cell.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        focusableElements.forEach(element => {
          element.setAttribute('tabindex', '-1');
        });
      });

      // set tabindex=0 only for the selected cell
      if (selectedCell) {
        const focusableElements = selectedCell.querySelectorAll('a, button, input, select, textarea, [tabindex="-1"]');
        focusableElements.forEach(element => {
          element.setAttribute('tabindex', '0');
        });
      }
    }

    // Initial setup
    updateCellsTabindex();
  }

  // For galleries that might be dynamically added to the page later
  const bodyObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('slider-gallery')) {
              if (node.classList.contains('flickity-enabled') &&
                  !node.hasAttribute('data-accessibility-initialized')) {
                node.setAttribute('data-accessibility-initialized', 'true');
                setupGalleryAccessibility(node);
              } else {
                // Set up observer for this new gallery
                const newGalleryObserver = new MutationObserver((mutations) => {
                  for (const mutation of mutations) {
                    if (mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('flickity-enabled') &&
                        !mutation.target.hasAttribute('data-accessibility-initialized')) {
                      mutation.target.setAttribute('data-accessibility-initialized', 'true');
                      setupGalleryAccessibility(mutation.target);
                      break;
                    }
                  }
                });

                newGalleryObserver.observe(node, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }
            }
            const nestedGalleries = node.querySelectorAll ? node.querySelectorAll('.slider-gallery') : [];
            for (const nestedGallery of nestedGalleries) {
              if (nestedGallery.classList.contains('flickity-enabled') &&
                  !nestedGallery.hasAttribute('data-accessibility-initialized')) {
                nestedGallery.setAttribute('data-accessibility-initialized', 'true');
                setupGalleryAccessibility(nestedGallery);
              } else {
                // Set up observer for this nested gallery
                const nestedGalleryObserver = new MutationObserver((mutations) => {
                  for (const mutation of mutations) {
                    if (mutation.type === 'attributes' &&
                        mutation.attributeName === 'class' &&
                        mutation.target.classList.contains('flickity-enabled') &&
                        !mutation.target.hasAttribute('data-accessibility-initialized')) {
                      mutation.target.setAttribute('data-accessibility-initialized', 'true');
                      setupGalleryAccessibility(mutation.target);
                      break;
                    }
                  }
                });

                nestedGalleryObserver.observe(nestedGallery, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }
            }
          }
        }
      }
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Product card quick view focus
document.addEventListener('keydown', function (event) {
  const quickView = event.target.closest('.product-image__wrapper .js-quick-shop-link');
  if (!quickView) return;
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    quickView.click();
  }
});

// Product page color swatches
document.addEventListener('change', function(event) {
  const radio = event.target;
  if (!radio.matches('[data-variant-option-value]')) return;

  setTimeout(() => {
    radio.focus();
  }, 0);
});

// Product listing color swatches
document.addEventListener('DOMContentLoaded', function () {

  const swatches = document.querySelectorAll('.thumbnail-swatch .swatch');

  swatches.forEach((swatch, index) => {

    swatch.addEventListener('focus', function () {
      updateSwatchImage(this);
    });

    swatch.addEventListener('keydown', function (e) {

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        updateSwatchImage(this);
      }

      if (e.key === 'ArrowRight') {
        e.preventDefault();

        const next = swatches[index + 1];

        if (next) {
          next.focus();
          updateSwatchImage(next);
        }
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();

        const prev = swatches[index - 1];

        if (prev) {
          prev.focus();
          updateSwatchImage(prev);
        }
      }
    });
  });

  function updateSwatchImage(swatch) {

    const span = swatch.querySelector('span');

    if (!span) return;

    const image = span.dataset.image;

    if (!image || image.indexOf('no-image') !== -1) return;

    const thumbnail = swatch.closest('.thumbnail');

    if (!thumbnail) return;

    const productImage = thumbnail.querySelector(
      '.product__imageContainer img:not(.secondary)'
    );

    if (!productImage) return;

    productImage.setAttribute('src', image);
    productImage.setAttribute('srcset', image);
  }
});

// Product quantity(+,-) keyboard accessiblity issue
document.addEventListener('keydown', function (event) {

  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );

  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {

    event.preventDefault();

    const quantityBox = button.closest(
      '.product-quantity-box'
    );

    if (!quantityBox) return;

    // Save focused button type
    const isPlus = button.classList.contains('quantity-plus');

    // Save line item identifier
    const lineItemKey = quantityBox.dataset.lineItemKey;

    // Trigger existing theme logic
    button.click();

    // Wait for AJAX/cart rerender
    setTimeout(() => {

      const updatedQuantityBox = document.querySelector(
        '.product-quantity-box[data-line-item-key="' +
        lineItemKey +
        '"]'
      );

      if (!updatedQuantityBox) return;

      const focusButton = updatedQuantityBox.querySelector(
        isPlus
          ? '.quantity-plus'
          : '.quantity-minus'
      );

      if (focusButton) {
        focusButton.focus();
      }

    }, 500);
  }
});

document.addEventListener('DOMContentLoaded', function () {

  const quantityButtons = document.querySelectorAll(
    '.cart__quantity .quantity-minus, .cart__quantity .quantity-plus'
  );

  quantityButtons.forEach(function (button) {

    button.addEventListener('keydown', function (event) {

      if (event.key === 'Enter' || event.key === ' ') {

        // Prevent cart form submission
        event.preventDefault();
        event.stopPropagation();

        // Trigger existing click logic
        this.click();
      }
    });
  });

});

/*document.addEventListener('keydown', function (event) {
  const button = event.target.closest(
    '.quantity-minus, .quantity-plus'
  );
  if (!button) return;

  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    const wrapper = button.closest('.quantity-wrapper');
    if (!wrapper) return;
    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;
    let value = parseInt(input.value, 10) || 1;

    // Increase quantity
    if (button.classList.contains('quantity-plus')) {
      value++;
    }

    // Decrease quantity
    if (button.classList.contains('quantity-minus') && value > 1) {
      value--;
    }

    input.value = value;

    input.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }

});*/

// Close button fix on cart page
document.addEventListener('keyup', function(event) {

  const removeButton = event.target.closest(
    '.cart__remove .ajax-cart__delete'
  );

  if (!removeButton) return;

  if (event.key === 'Enter') {

    event.preventDefault();
    event.stopImmediatePropagation();

    const removeUrl = removeButton.dataset.removeUrl;

    if (removeUrl) {
      window.location.assign(removeUrl);
    }
  }

});